import { UIElements } from '@ansvar-sakerhet/ui';
import { styled } from 'styled-components';

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: space-between;
  flex-grow: 1;
  height: 90%;
`;

const FrameCompanies = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const S = {
  TableContainer,
  FrameCompanies,
  ...UIElements,
};
